$(document).ready(function () {
    var rtl = $('html').attr('dir') === 'rtl';
    
    $(".products-related .slider-items").each(function () {
        var thisElement = $(this);

        thisElement.slick({
            centerMode: false,
            variableWidth: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: thisElement.closest('.products-related').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.products-related').find('.sliderNextButton'),
            mobileFirst: true,
            rtl: rtl,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });

        if (rtl) {
            thisElement.slick('slickSetOption', 'rtl', true, true);
        }
    })
    
    $(".slider-links").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            fade: false,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            rtl: rtl,
            responsive: [{
                breakpoint: 578,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            },
            ]
        });
        if (rtl) {
            thisElement.slick('slickSetOption', 'rtl', true, true);
        }
    });

    $(".slider-publications").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            fade: false,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            rtl: rtl,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },]
        });
        if (rtl) {
            thisElement.slick('slickSetOption', 'rtl', true, true);
        }
    });

    $(".slider-gallery").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            fade: true,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            rtl: rtl
        });
        if (rtl) {
            thisElement.slick('slickSetOption', 'rtl', true, true);
        }
    });

    $(".slider-gallery-alt").each(function () {
        var thisElement = $(this);
        var $sliderParent = $(this).parent();
        var helpers = {
            addZeros: function (n) {
                return n.toString();
            }
        };
        thisElement.slick({
            fade: true,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: thisElement.closest('.slider-gallery-alt-wrap').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.slider-gallery-alt-wrap').find('.sliderNextButton'),
            rtl: rtl
        });
        if (rtl) {
            thisElement.slick('slickSetOption', 'rtl', true, true);
        }
        if ($(this).find('.slider-gallery-alt-item').length > 1) {
            $(this).siblings('.slidesNumbers').show();
        }

        $(this).on('afterChange', function (event, slick, currentSlide) {
            $sliderParent.find('.slidesNumbers .active').html(helpers.addZeros(currentSlide + 1));
        });

        var sliderItemsNum = $(this).find('.slick-slide').not('.slick-cloned').length;
        $sliderParent.find('.slidesNumbers .total').html(helpers.addZeros(sliderItemsNum));
    });

    $(".slider-home").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            fade: true,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            prevArrow: thisElement.closest('.home-slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.home-slider').find('.sliderNextButton'),
            mobileFirst: true,
            rtl: rtl,
            responsive: [{
                breakpoint: 768,
                settings: {
                    dots: true,
                }
            },]
        });
        if (rtl) {
            thisElement.slick('slickSetOption', 'rtl', true, true);
        }

        var slideCount = $(this).find('.slick-slide').length;

        // hide the pause button if only one slide
        if (slideCount === 1) {
            $('.slick-autoplay-toggle-button').hide();
            $('.slider-button-wrap').css('opacity', '0');
        }
    })

    $(".slider-spotlight").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            fade: true,
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            rtl: rtl
        });
        if (rtl) {
            thisElement.slick('slickSetOption', 'rtl', true, true);
        }

        var slideCount = $(this).find('.slick-slide').length;

        // hide the pause button if only one slide
        if (slideCount === 1) {
            $('.slick-autoplay-toggle-button').hide();
        }

    });

    $(".slider-testimonials").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            fade: true,
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            rtl: rtl
        });
        if (rtl) {
            thisElement.slick('slickSetOption', 'rtl', true, true);
        }

        var slideCount = $(this).find('.slick-slide').length;

        // hide the pause button if only one slide
        if (slideCount === 1) {
            $('.slick-autoplay-toggle-button').hide();
        }
    })

    $(".slider-variable").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            rtl: rtl,
        });
        if (rtl) {
            thisElement.slick('slickSetOption', 'rtl', true, true);
        }
    });
});